$(document).ready(function(){
	
	if ($('#product-params').length && $('#product-params').data('file-id-entity'))
	{
		var ids = [],
			ids_data = $('#product-params').data('file-id-entity').toString();
		
		if (ids_data.indexOf(';') > -1){
			ids = ids_data.split(';');
		} else {
			ids.push(ids_data);
		};

		$.each( ids, function( index, value ) {
			$.ajax({
				type: "GET",
				url: cyclone3.domain + '/chunk/file_table?ID_entity=' + value,
				dataType: 'html',
				xhrFields: {
					withCredentials: true
				},
				success: function(response){
					try{
						var result = $(response).filter('#chunk').html();
						$('#product-params').append(result);
					}catch(e){
						cyclone3.log('[load file table] error ' + e);
					}
				}
			});
		});
	}
});